import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, FileText, Mail, UserCog, Bell, Type, CreditCard, Clock } from 'lucide-react';
import { Card } from '../components/ui/Card';
export function AdminArea() {
  const menuItems = [{
    label: 'Edit Static Pages',
    href: '/static-pages',
    icon: FileText
  }, {
    label: 'Change Email Details',
    href: '/email-details',
    icon: Mail
  }, {
    label: 'Edit User Profile Custom Fields',
    href: '/custom-fields',
    icon: UserCog
  }, {
    label: 'Edit E-mail Notifications',
    href: '/notifications',
    icon: Bell
  }, {
    label: 'Edit direction text',
    href: '/direction-text',
    icon: Type
  }, {
    label: 'Manage credit types',
    href: '/credit-types',
    icon: CreditCard
  }, {
    label: 'Switch Expired Class',
    href: '/switch-expired',
    icon: Clock
  }];
  return <div className="space-y-6" data-id="element-315" data-mp="3oycy5j2veo4b">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-316" data-mp="3oz4k026o17he">Admin Area</h1>

      <Card className="divide-y divide-slate-200" data-id="element-317" data-mp="3twwl9mt7a5y9">
        {menuItems.map(item => <Link key={item.label} to={item.href} className="flex items-center justify-between p-4 hover:bg-slate-50 transition-colors group" data-id="element-318" data-mp="3f89v0q21bts9">
            <div className="flex items-center gap-4" data-id="element-319" data-mp="3k50bhehr4re7">
              <div className="h-10 w-10 rounded-full bg-slate-100 flex items-center justify-center group-hover:bg-white group-hover:shadow-sm transition-all" data-id="element-320" data-mp="366sitirr0c8u">
                <item.icon className="h-5 w-5 text-slate-600" data-id="element-321" data-mp="2w9nv3ei988px" />
              </div>
              <span className="font-medium text-slate-900" data-id="element-322" data-mp="2wbs4gbyx9zxl">{item.label}</span>
            </div>
            <ChevronRight className="h-5 w-5 text-slate-400 group-hover:text-slate-600" data-id="element-323" data-mp="31abtil8tbru6" />
          </Link>)}
      </Card>
    </div>;
}